import { styled, Button } from '@ori-ui/mui';

export const Root = styled(Button)(({ theme }) => ({
  width: `calc(100% - ${theme.spacing(2)})`,
  margin: theme.spacing(1),
}));
